<script lang="ts">
export default { name: 'LayoutMain', inheritAttrs: false }
</script>

<script lang="ts" setup>
import { ref, inject, watch } from 'vue'
import { LayoutDataKey } from './use-layout-data'

const layout = inject(LayoutDataKey)

/** main要素 */
const mainEl = ref<HTMLElement | null>(null)

watch(
  () => layout,
  () => {
    if (layout && mainEl.value) {
      // header
      mainEl.value.style.paddingTop = `${layout.header?.height}px`
      // footer
      mainEl.value.style.paddingBottom = `${layout.footer?.height + layout.float.bottom.height}px`
    }
  },
  { immediate: true, deep: true },
)
</script>

<template>
  <main ref="mainEl" class="relative min-h-full">
    <slot />
  </main>
</template>
